const useScrollTo = () => {
    const scrollToTop = () => {
        document.getElementById('root').scrollTo({ top: 0, behavior: 'smooth' })
    }

    return { scrollToTop }
}

export default useScrollTo
